module.exports = __webpack_public_path__ + "static/sport/loading.19f6dad.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport4/loading.gif
// module id = VRls
// module chunks = 0